import { render, staticRenderFns } from "./table1.vue?vue&type=template&id=3993397d&scoped=true&"
import script from "./table1.vue?vue&type=script&lang=js&"
export * from "./table1.vue?vue&type=script&lang=js&"
import style0 from "./table1.vue?vue&type=style&index=0&id=3993397d&prod&lang=less&"
import style1 from "./table1.vue?vue&type=style&index=1&id=3993397d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3993397d",
  null
  
)

export default component.exports